import { useState, useRef, useCallback } from 'react'
import axios from 'axios'
import { MONSTER_CANDIDATE_DETAILS_V2 } from '../../../../../ApiUrl'
import { requestHeader } from '../../../../../others/header'

export const useCandidateDetails = () => {
  const [detailsCache, setDetailsCache] = useState({})
  const [loading, setLoading] = useState({})
  const [error, setError] = useState({})
  const abortControllersRef = useRef({})

  const fetchDetails = useCallback(async (candidateData) => {
    const sid = candidateData?.id;
    if (!sid) {
      console.error('No SID found in candidate data:', candidateData);
      return;
    }

    if (abortControllersRef.current[sid]) {
      abortControllersRef.current[sid].abort();
    }

    const controller = new AbortController();
    abortControllersRef.current[sid] = controller;
    
    setLoading(prev => ({ ...prev, [sid]: true }));
    setError(prev => ({ ...prev, [sid]: null }));

    try {
      // Single request to get all candidate details
      const response = await axios.get(
        `${MONSTER_CANDIDATE_DETAILS_V2}/${sid}`,
        {
          ...requestHeader(),
          signal: controller.signal
        }
      );

      if (response.data.error) {
        throw new Error(response.data.message);
      }

      const { candidateId, candidate, fromDB } = response.data.data;
      
      // Store the candidate data in the cache
      setDetailsCache(prev => ({
        ...prev,
        [sid]: {
          data: candidate,
          candidateId: candidateId,
          fromDB: fromDB,
          timestamp: Date.now()
        }
      }));

      return candidate;
    } catch (err) {
      console.error('Error in fetchDetails:', err);
      if (err.name !== 'CanceledError') {
        setError(prev => ({ ...prev, [sid]: err.message }));
      }
      throw err;
    } finally {
      setLoading(prev => ({ ...prev, [sid]: false }));
      delete abortControllersRef.current[sid];
    }
  }, []);

  return { fetchDetails, detailsCache, loading, error }
}
